module.exports = __webpack_public_path__ + "static/img/cha.8eec2be0.png";